import { SET_DIALOG, SET_SNACKBAR, SET_WARNING_POPUP } from "./commonActionTypes";
import { CommonInitialStateInterface } from "./type";

const initialState: CommonInitialStateInterface = {
	snackbar: null,
	dialog: {
		open: false,
		config: { title: "", content: "" },
	},
	warningpopup: {
		open: false,
		config: {
			classNames: {},
			content: "",
			actions: [],
		},
	},
};

function reducer(state = initialState, action: any): CommonInitialStateInterface {
	switch (action.type) {
		case SET_SNACKBAR:
			return { ...state, snackbar: action.data };
		case SET_DIALOG:
			return {
				...state,
				dialog: { open: action.open, config: action.config ?? null },
			};
		case SET_WARNING_POPUP:
			return {
				...state,
				warningpopup: { open: action.open, config: action.data ?? null },
			};

		default:
			return state;
	}
}

export default reducer;
